export const GsCtaAnswerFrag = `
fragment GsCtaAnswerFrag on GsCtaAnswer { 
  text {
    value
  }
  nextQuestion {
    id: targetId
  }
  service {
    id: targetId
  }
}
`;
